module.exports = __webpack_public_path__ + "img/qggitem1.6f13797d.png";